// extracted by mini-css-extract-plugin
export default {"conversationListHeading":"ConversationList-module__conversationListHeading--U8Nfn","inner":"ConversationList-module__inner--QpzYH"};